<div *ngIf="content">
  <a href="javascript:void(0)" (click)="onLinkClick()">
      Customer(s)
  </a>

</div>
<div *ngIf="!content">
  <p>N/A</p>
</div>